import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import { P3Desk } from "../../styles/styles_text";
import NewFilter from "../../assets/kinologyIcons/svg/new_filter.svg";
import WithFilter from "../../assets/kinologyIcons/svg/with_filter.svg";
import Filter from "./Filter";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table"
import { useDispatch, useSelector } from "react-redux";
import { DashBoardActions } from "../../store/ducks/dashboard";
import { AppActions } from "../../store/ducks/app";
import { TextsProps } from "../../database/txt.interface";

interface DonutChartProps {
	title: string;
	subtitle?: string;
	data: Array<any> | [];
	onDonutChange?: (selected: string[]) => void;
	assimetrya: any;
	defaultFilter: any
}

interface usuariosProps {
		cargo: string;
		resultado: string;
		resultados: string;
		user: number;
		user_nome: string;
		possui_incoerencia: boolean;
	}
	interface changeProps {
		changeLevel: number;
		fill: string;
		name_risco: string;
		usuarios: Array<usuariosProps>;
		valor_risco: number;
		filter_tag: {
			ano: number,
			mes: string
		}
		
	};
	interface formatdataProps  { 
		fill: string; 
		valor_risco: number; 
		user: number; 
		entrance_door?: any; 
		user_nome: string; 
		name_risco: string; 
		has_inconsistency: boolean
	}
interface entranceDoorType {
	ID_PORTA_ENTRADA: number;
	PORTA_ENTRADA_ATUALIZADO: string;
	PORTA_ENTRADA_CRIADO: string;
	PORTA_ENTRADA_EXCLUIDO: string;
	PORTA_ENTRADA_TITULO: string;
}

const TableHighPriority: React.FC<DonutChartProps> = ({
	title,
	data,
	onDonutChange,
	defaultFilter,
	assimetrya,
}) => {
	const dispatch = useDispatch();
	const pacientes = useSelector((state: any) => state.dashboard.pacientes);
	const avaliacoes_dynalabs = useSelector((state: any) => state.dashboard.avaliacoes_dynalabs);
	const entrance_door_data: Array<entranceDoorType> = useSelector((state:any)=> state.dashboard.entrance_door_data);
	const current_language: TextsProps = useSelector((state: any) => state.configs.current_language	);

	const [dataTableHighPriority, setDataTableHighPriority] = useState<formatdataProps[]>([]);
	const [with_filter, set_with_filter] = useState(false);
	const [selected_patient, set_selected_patient] = useState();
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const onFilterChange = (selected: any) => {
		const aux_filter = Object.entries(selected)
		set_with_filter(aux_filter.length > 0 ? true : false)
		onDonutChange?.(selected)
	};

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

	function filtrarUsuariosPorMaiorRisco(data: any[]) {
		const prioridade = ["negativo_2", "negativo_1", "intermediario", "positivo"];

		const usuariosUnicos = new Map();

		const novaData = [];

		for (const key of prioridade) {
			const grupo = data?.find((item) => item?.key === key);
			if (!grupo) continue; 

			const usuariosFiltrados = grupo?.usuarios?.filter((usuario: { user: any; }) => {
				if (!usuariosUnicos.has(usuario.user)) {
					usuariosUnicos.set(usuario.user, true); 
					return true; 
				}
				return false; 
			});

			novaData.push({
				...grupo,
				usuarios: usuariosFiltrados,
				valor_risco: usuariosFiltrados.length, 
			});
		}

		return novaData;
	}

	

	useEffect(()=>{
		const formatData: formatdataProps[] = [];

	
		filtrarUsuariosPorMaiorRisco(data)?.forEach((changes:changeProps)=>{
			changes?.usuarios?.map((users)=>(
				formatData.push({
					fill: changes.fill,
					user: users?.user,
					valor_risco: changes?.valor_risco,
					user_nome: users?.user_nome,
					name_risco: changes?.name_risco,
					entrance_door: assimetrya?.assimetrias?.find((item: { ID_USUARIO: number; })=> item.ID_USUARIO == users.user)?.ID_PORTA_ENTRADA,
					has_inconsistency: users?.possui_incoerencia
				})
			))
		});

		if(formatData.length > 0){
			setDataTableHighPriority(formatData)
		}

	},[assimetrya, data, defaultFilter, avaliacoes_dynalabs])
	
	const ChangeComponent = (item:formatdataProps)=> {

		return (
			<div className={`flex flex-row w-full  items-center`}>
				<div className={`w-[16px] h-[16px] rounded-full mr-1`} style={{backgroundColor: item?.fill}}/>
				<p className={`text-[#3D4259]`}>
					{item?.name_risco}
				</p>
			</div>
		)
	};
	const EntranceDoorComponent = (item:formatdataProps)=> {
		return(
			<div className={	item?.entrance_door && entrance_door_data.length > 0 && !!entrance_door_data?.find((entrance: entranceDoorType)=> entrance?.ID_PORTA_ENTRADA == Number(item?.entrance_door))
					? `flex rounded-2xl px-5 py-[2px] items-center justify-center bg-[#CEF6E7]`
					: `flex rounded-2xl px-2 2xl:px-3 py-[2px] items-center justify-center border border-[#C4C5CC]`
				}
			>
				{
					!!item?.entrance_door && entrance_door_data.length > 0 && !!entrance_door_data?.find((entrance: entranceDoorType)=> entrance?.ID_PORTA_ENTRADA == Number(item?.entrance_door))
					? entrance_door_data?.find((entrance: entranceDoorType)=> entrance?.ID_PORTA_ENTRADA == Number(item?.entrance_door))?.PORTA_ENTRADA_TITULO
					: current_language?.nao_informado
				}
			</div>
		)
	};
	
	const CoherenceComponent = (item:formatdataProps)=> {

		return(
			<div className={item.has_inconsistency 
					? `flex rounded-2xl px-3 2xl:px-3 py-[2px] items-center justify-center bg-[#E5887380]`
					: `flex rounded-2xl px-3 py-[2px] items-center justify-center bg-[#CEF6E7]`
				}>
				{	item.has_inconsistency 	? current_language?.not : current_language?.yes }
			</div>
		)
	};


	const navigateUserProfile = (paciente: any) => {
		const filtros_paginacao = {
			inicio: 0,
			fim: 1,
			filtros: [
				{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
				{ tipo: "USUARIO_NIVEL", valor: [3] },
				{ tipo: "ID_USUARIO", valor: [paciente] },
			],
		};

		dispatch(DashBoardActions.set_filtros_pacintes_request(filtros_paginacao));
		dispatch(DashBoardActions.paciente_request());
		set_selected_patient(paciente)
	};

	useEffect(() => {
		if(selected_patient){
			dispatch(AppActions.set_open_paciente(pacientes[0]));
			dispatch(DashBoardActions.set_current_page("perfil_paciente"));
		}
	}, [pacientes])

	return (
		<Card	className={`flex flex-col bg-white mt-3 relative px-12`}	>
			<div className={`absolute top-4 right-4 `}>
				<Filter icon={with_filter ? WithFilter : NewFilter} onFilterChange={ onFilterChange} defaultFilter={defaultFilter} GraphType={title} />
			</div>
			<P3Desk className={`text-center mt-5`}>{title}</P3Desk>
			
			<CardContent className={`mt-7 p-0`}>
				<div className={`flex flex-row justify-center mb-20 w-full `}	>
					<Table	className={`flex flex-col border rounded-xl overflow-x-hidden`}>
						<TableHeader 	className={`flex flex-row bg-[#F1F2F3] rounded-tl-xl rounded-tr-xl `}>
							<TableRow 	className={`flex flex-row w-full justify-center text-[#3D4259] `}>
								<TableHead 	className={`flex items-center min-w-[31%]`} >
									{current_language?.alteracao}
								</TableHead>
								<TableHead className={`flex items-center min-w-[29%] 2xl:min-w-[30%] `}>
									{current_language?.pag_inicial_pacientes}
								</TableHead>
								<TableHead className={`flex items-center justify-center min-w-[19%] 2xl:min-w-[20%] `}>
									{current_language?.porta_entrada_dash}
								</TableHead>
								<TableHead 	className={`flex items-center min-w-[20%] `}>
									{current_language?.coerencia_clinica_dash}
								</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody className={dataTableHighPriority.length >= 10 ? `flex w-full max-h-[380px] flex-col p-0 sm:px-1 overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-[#DEDFE3] scrollbar-track-transparent` : `flex w-full flex-col p-0 sm:px-1`}>
							{
								dataTableHighPriority?.map((item, index, array)=>(
									<TableRow className={index % 2 == 0  ? `flex w-full bg-[#F1F2F3100] text-[#3D4259]` : `flex w-full bg-[#F1F2F350] text-[#3D4259]` } key={index}>
										<TableCell 	className={`flex items-center min-w-[31%]  p-0 text-sm `}	>
											{ChangeComponent(item)}
										</TableCell>
										<TableCell 	
											onClick={()=> {navigateUserProfile(item?.user)}}
											className={`flex items-center min-w-[31%] 2xl:min-w-[30%] underline cursor-pointer text-sm overflow-hidden`}	
										>
											{
												item.user_nome.length >= 30 && windowWidth <= 1440
													? item.user_nome.slice(0,25)+`...`
													: item.user_nome
											}
										</TableCell>
										<TableCell className={`flex items-center justify-center min-w-[20%] 2xl:min-w-[22%] px-0 text-sm`}>
										{EntranceDoorComponent(item)}
										</TableCell>
										<TableCell 	className={`flex items-center min-w-[20%] 2xl:w-[20%] pl-5 text-sm	`}	>
											{CoherenceComponent(item)}
										</TableCell>
									</TableRow>
								))
							}
						</TableBody>
					</Table>
				</div>
			</CardContent>
		</Card>
	);
};
export default TableHighPriority;
